import { IntegrationStage } from '../enums/integration-stage';
import { VariableConfigTypes } from '../types/secret-config-types';

export function getVariableValue(
	integrationStage: IntegrationStage,
	variableConfigTypes: VariableConfigTypes
) {
	switch (integrationStage) {
		case IntegrationStage.Develop:
			return variableConfigTypes.devValue;
		case IntegrationStage.Testing:
			return variableConfigTypes.testValue;
		case IntegrationStage.Production:
			return variableConfigTypes.prodValue;
		default:
			throw new Error(`Invalid integration stage: ${integrationStage}`);
	}
}
